/// <reference types="node" />
// correctly type "require"
import memoize from 'lodash/memoize';
import getLanguageFromLocale from '@atlassian/jira-common-localisation/src/utils/get-language-from-locale.tsx';
import { getIntl } from '@atlassian/jira-intl/src/get-intl.tsx';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

export type MessageValues = {
	[key: string]: string | number;
};

export const createFormatMessage: (
	locale: string,
) => (messageDescriptor: MessageDescriptor, messageValues?: MessageValues) => string = memoize(
	(locale: string) => {
		// TODO: providing locale to IntlProvider is nothing to do with translation. We can completely remove language, not providing any locale
		// TODO: React-intl just reads whatever given to messages object, regardless of locale. REMOVE THIS
		// IntlProvider cannot deal with locale w/ country code. Needs language-only.
		const language = getLanguageFromLocale(locale);
		// disable flow for unresolved externals module
		// disable eslint for both unresolved module
		// eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
		const messages = require('language-pack');
		const intl = getIntl({ locale: language, messages });
		return intl.formatMessage;
	},
);
